import { render, staticRenderFns } from "./DashIndex.vue?vue&type=template&id=78e0d260&scoped=true&"
import script from "./DashIndex.vue?vue&type=script&lang=js&"
export * from "./DashIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0d260",
  null
  
)

export default component.exports